<app-breadcrumb [title]="'Riesgos de desplazamientos'" [items]="['Pesv', 'Desplazamientos']"
  [active_item]="'Riesgos del desplazamiento'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card shadow-sm border-0">
    <div class="card-header bg-primary text-white d-flex align-items-center">
      <i class="icofont icofont-warning me-2"></i>
      <h5 class="mb-0"><strong>RIESGOS DEL DESPLAZAMIENTO</strong></h5>
      <button type="button" class="btn btn-sm btn-light ms-auto" (click)="volver()">
        <i class="icofont icofont-arrow-left me-1"></i>Volver
      </button>
    </div>

    <div class="card-body">

      <!-- INFORMACIÓN DEL DESPLAZAMIENTO -->
      <div class="card border-0 shadow-sm mb-3" *ngIf="desplazamiento">
        <div class="card-body row g-3">
          <div class="col-md-3">
            <small class="text-primary d-block">N° documento</small>
            <strong>{{ desplazamiento.n_documento || '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Fecha</small>
            <strong>{{ desplazamiento.fecha ? (desplazamiento.fecha | date:'dd/MM/yyyy') : '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Origen</small>
            <strong>{{ desplazamiento.PesvOrigenDesplazamientosData?.MUNICIPIO || '-' }}</strong>
          </div>
          <div class="col-md-3">
            <small class="text-primary d-block">Destino</small>
            <strong>{{ desplazamiento.PesvDestinoDesplazamientosData?.MUNICIPIO || '-' }}</strong>
          </div>
        </div>
      </div>

      <ul ngbNav #riesgoTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

        <!-- TAB 1: FORMULARIO -->
        <li [ngbNavItem]="1" *ngIf="desplazamientoActivo || modoEdicion">
          <a ngbNavLink><strong><i class="icofont icofont-plus me-1"></i> FORMULARIO RIESGO</strong></a>
          <ng-template ngbNavContent>
            <form [formGroup]="riesgoForm" (ngSubmit)="guardar()" class="pt-3" novalidate>
              <div class="card border-0 shadow-sm mb-3">
                <div class="card-body row g-3">

                  <div class="col-md-4">
                    <label class="form-label text-dark">Tipo de riesgo: <span class="text-danger">*</span></label>
                    <ng-select [items]="tiposRiesgo" bindLabel="descripcion" bindValue="id" [addTag]="true" addTagText="Agregar"
                      [searchable]="true" [clearable]="true"
                      placeholder="Seleccione o escriba un tipo..." formControlName="tipo_riesgo"
                      [class.is-invalid]="riesgoForm.get('tipo_riesgo')?.invalid && riesgoForm.get('tipo_riesgo')?.touched">
                    </ng-select>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark">Nivel de riesgo:</label>
                    <ng-select [items]="nivelesRiesgo" bindLabel="descripcion" bindValue="id" [searchable]="false" [clearable]="true"
                      placeholder="Seleccione un nivel..." formControlName="nivel_riesgo">
                    </ng-select>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark">Responsable:</label>
                    <ng-select [items]="colaboradores" bindLabel="nombreCompleto" bindValue="cedula"
                      [loading]="cargandoColaboradores" [searchable]="true" [clearable]="true"
                      placeholder="Seleccione un colaborador..." formControlName="responsable">
                      <ng-template ng-option-tmp let-colaborador="item">
                        <div>{{ colaborador.nombreCompleto }} - {{ colaborador.cargo }}</div>
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Descripción: <span class="text-danger">*</span></label>
                    <textarea class="form-control" rows="3" formControlName="descripcion"
                      [class.is-invalid]="riesgoForm.get('descripcion')?.invalid && riesgoForm.get('descripcion')?.touched"></textarea>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Control / medida de mitigación</label>
                    <textarea class="form-control" rows="3" formControlName="control"></textarea>
                  </div>

                </div>
              </div>

              <div class="d-flex justify-content-center gap-2 mt-4">
                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                  <span *ngIf="!guardando">
                    <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                  </span>
                  <span *ngIf="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span>Guardando...
                  </span>
                </button>
                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion" (click)="cancelarEdicion()">
                  <i class="icofont icofont-close me-1"></i>Cancelar edición
                </button>
              </div>
            </form>
          </ng-template>
        </li>

        <!-- TAB 2: LISTADO -->
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO RIESGOS</strong></a>
          <ng-template ngbNavContent>
            <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
              <div class="card-body pt-3">

                <div *ngIf="cargandoListado" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="mt-2 mb-0">Cargando riesgos...</p>
                </div>

                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                  <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                      <option [ngValue]="null">Todos</option>
                      <option [ngValue]="1">Activos</option>
                      <option [ngValue]="0">Inactivos</option>
                    </select>
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="input-group">
                      <input type="text" class="form-control"
                        placeholder="Buscar por tipo, descripción, nivel, responsable..." [(ngModel)]="filtro"
                        (input)="aplicarFiltro()">
                      <span class="input-group-text"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>

                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                  <ng-container *ngIf="riesgosFiltrados.length > 0; else sinDatos">
                    <table id="tblRiesgosDesplazamientos" class="table table-bordered table-hover align-middle">
                      <thead class="bg-primary text-white">
                        <tr>
                          <th class="text-center">TIPO DE RIESGO</th>
                          <th class="text-center">DESCRIPCIÓN</th>
                          <th class="text-center">NIVEL</th>
                          <th class="text-center">CONTROL</th>
                          <th class="text-center">RESPONSABLE</th>
                          <th class="text-center">ESTADO</th>
                          <th class="text-center">ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let r of riesgosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }">
                          <td class="text-center">{{ r.TipoRiesgoDesplazamientoData?.descripcion }}</td>
                          <td>{{ r.descripcion }}</td>
                          <td class="text-center">
                            {{ r.NivelRiesgoDesplazamientoData?.descripcion || 'Sin nivel' }}
                          </td>
                          <td>{{ r.control || '-' }}</td>
                          <td class="text-center text-uppercase">{{ r.ResponsableDesplazamientoData?.nombreCompleto }}</td>
                          <td class="text-center">
                            <span class="badge rounded-pill" [ngClass]="{
                                'bg-success': r.estado === 1,
                                'bg-secondary': r.estado !== 1
                              }">
                              {{ r.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                            </span>
                          </td>
                          <td class="text-center">
                            <div class="d-flex justify-content-center gap-1">
                              <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                ngbTooltip="Editar" *ngIf="r.estado === 1" (click)="editar(r)">
                                <i class="icofont icofont-pencil" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-danger rounded-pill btn-rounded"
                                ngbTooltip="Inactivar" *ngIf="r.estado === 1" (click)="inactivar(r)">
                                <i class="icofont icofont-close" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                ngbTooltip="Activar" *ngIf="r.estado !== 1" (click)="activar(r)">
                                <i class="icofont icofont-check" style="font-size:.85rem;"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="d-flex align-items-center">
                        <label class="me-2">Mostrar:</label>
                        <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                          <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>
                      <div class="text-center flex-grow-1">
                        Total Registros: <a class="badge badge-primary"><b>{{ riesgosFiltrados.length || 0
                            }}</b></a>
                      </div>
                      <div class="text-end">
                        <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #sinDatos>
                    <div class="text-center py-4 text-primary">No hay riesgos registrados para este desplazamiento.</div>
                  </ng-template>
                </div>

                <div class="mt-4">
                  <div class="btn-showcase text-center">
                    <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                      (click)="exportarExcel('tblRiesgosDesplazamientos','listado_riesgos_desplazamientos')">
                      <i class="icofont icofont-file-excel"></i> EXCEL
                    </button>
                    <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                      (click)="exportToPDF('tblRiesgosDesplazamientos','listado_riesgos_desplazamientos','Listado de riesgos del desplazamiento')">
                      <i class="icofont icofont-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="riesgoTab" class="mt-2"></div>
    </div>
  </div>
</div>